<template>
  <!--
    profileReping.vue
    =================
    Receives :post="item.post" from profilePage.vue's REPING tab.

    The post object shape (from PostSerializer):
    {
      id:            number
      content:       string
      files:         string | null   (URL to image/video)
      link:          string
      views:         number
      likes:         number
      reposts_count: number
      shares:        number
      created_at:    string (ISO datetime)
      user: {
        id:            number
        first_name:    string
        last_name:     string
        profile_image: string (absolute URL built by serializer)
      }
    }
  -->
  <v-col cols="12" sm="6" md="4">
    <v-card
      outlined
      class="pa-1 d-flex flex-column"
      style="max-height: 360px;"
    >

      <!-- ── Header: avatar + name + reposted badge + timestamp ── -->
      <v-list-item dense class="pl-2 pr-2">
        <v-list-item-avatar size="36">
          <v-img :src="post.user.profile.profile_image" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold text-subtitle-2">
           {{ post.user.first_name }} {{ post.user.last_name }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption grey--text">
            {{ timeAgo(post.created_at) }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <!-- "location" chip — matches the mdi-selection-marker icon
             used in postDetails.vue for the repost button -->
        <v-chip x-small color="grey lighten-3" class="ml-1">
          <v-icon x-small left color="red">mdi-map-marker</v-icon>
          {{post.location}}
        </v-chip>
      </v-list-item>

      <!-- ── Post image (same conditional as postDetails.vue) ── -->
      <v-img
        v-if="post.files"
        :src="post.files"
        height="160"
        class="mx-2 rounded-lg"
      />

      <!-- ── Post content ── -->
      <v-card-text
        class="pt-2 pb-1 black--text text-body-2 flex-grow-1"
        style="
          overflow-y: auto;
          overflow-wrap: anywhere;
          word-break: break-word;
          min-height: 0;
        "
      >
        {{ post.content }}

        <div v-if="post.link" class="mt-1">
          <a
            :href="post.link"
            target="_blank"
            style="color: deepskyblue; text-decoration: none; overflow-wrap: anywhere;"
          >
            {{ post.link }}
          </a>
        </div>
      </v-card-text>

      <!-- ── Engagement counts (read-only, no actions needed here) ── -->
      <v-card-actions class="pt-0 pb-1 pl-2 grey--text text-caption">
        <v-icon small color="grey" class="mr-1">mdi-eye-outline</v-icon>
        {{ post.views }}
        <v-icon small color="grey" class="mr-1 ml-3">mdi-comment-outline</v-icon>
        {{ post.comments.length }}
        <v-icon small color="grey" class="mr-1 ml-3">mdi-heart-outline</v-icon>
        {{ post.likes }}
        <v-icon small color="primary" class="mr-1 ml-3">mdi-selection-marker</v-icon>
        {{ post.reposts_count }}
        <v-icon small color="grey" class="mr-1 ml-3">mdi-share-variant</v-icon>
        {{ post.shares }}
      </v-card-actions>

    </v-card>
  </v-col>
</template>

<script>
const moment = require('moment')

export default {
  name: 'ProfileReping',

  props: {
    /**
     * Receives item.post from profilePage.vue.
     * Shape matches PostSerializer — see top comment.
     */
    post: {
      type:     Object,
      required: true,
    },
  },

  methods: {
    /**
     * Same moment.js pattern used in postDetails.vue → getTime()
     */
    timeAgo(date) {
      return moment(date).fromNow()
    },
  },
}
</script>